module.exports = __webpack_public_path__ + "static/media/logo25prod.b3bd70ef.png";